import { state } from "../../state/workspaceStore.js";
import { esc, initials } from "../../utils/format.js";
export const avatar = (cls = "avatar") =>
  state.db.profile.avatar ? (
    <img
      className={cls + " avatar-photo"}
      src={esc(state.db.profile.avatar)}
      alt={esc(state.db.profile.name) + " profile photograph"}
    />
  ) : (
    <span className={cls}>{initials(state.db.profile.name)}</span>
  );
